import { render, staticRenderFns } from "./mhospital2.vue?vue&type=template&id=9706dc5c&"
import script from "./mhospital2.vue?vue&type=script&lang=js&"
export * from "./mhospital2.vue?vue&type=script&lang=js&"
import style0 from "./mhospital2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports